module.exports = __webpack_public_path__ + "img/category_20.2ee8ad20.png";